var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 3.33332H5.16699C3.76686 3.33332 3.0668 3.33332 2.53202 3.6058C2.06161 3.84549 1.67916 4.22794 1.43948 4.69834C1.16699 5.23312 1.16699 5.93319 1.16699 7.33332V14.3333C1.16699 15.7335 1.16699 16.4335 1.43948 16.9683C1.67916 17.4387 2.06161 17.8212 2.53202 18.0608C3.0668 18.3333 3.76686 18.3333 5.16699 18.3333H12.167C13.5671 18.3333 14.2672 18.3333 14.802 18.0608C15.2724 17.8212 15.6548 17.4387 15.8945 16.9683C16.167 16.4335 16.167 15.7335 16.167 14.3333V10.8333M6.16697 13.3333H7.56242C7.97007 13.3333 8.1739 13.3333 8.36571 13.2873C8.53577 13.2464 8.69835 13.1791 8.84747 13.0877C9.01566 12.9847 9.15979 12.8405 9.44804 12.5523L17.417 4.58332C18.1073 3.89296 18.1073 2.77368 17.417 2.08332C16.7266 1.39296 15.6073 1.39296 14.917 2.08332L6.94802 10.0523C6.65977 10.3405 6.51564 10.4847 6.41257 10.6528C6.32119 10.802 6.25385 10.9645 6.21302 11.1346C6.16697 11.3264 6.16697 11.5302 6.16697 11.9379V13.3333Z",
    stroke: "#575757",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4e028970aea48a7fba51e27dbb8df7d6.svg";
export { ForwardRef as ReactComponent };